export default __webpack_public_path__ + "static/blog-post-most-popular-8a041797109c358210eba17869e7603a.png";